<template>
  <v-app>

    <v-app-bar app>
      <v-container class="py-0 fill-height" fluid>
        <v-avatar size="40">
          <v-img v-if="!$vuetify.theme.dark" :src="dc_logo" contain></v-img>
          <v-img v-if="$vuetify.theme.dark"  src="https://www.dreamcity.studio/images/logo.ico" contain></v-img>
        </v-avatar>
        <a href="https://www.dreamcity.studio/" target="_parent">
          <v-toolbar-title :style="`color:${$vuetify.theme.dark ? 'white' : 'black'}`" class="text-h6 mx-3"><b>夢想之都工作室</b></v-toolbar-title>
        </a>
        <div v-for="link in links" :key="link">
          <a v-if="$vuetify.breakpoint.width > 960 ? true : false" :href="link.src" target="_parent">
            <v-btn class="bt" text >
              {{ link.text }}
            </v-btn>
          </a>
          
        </div>

      </v-container>
      <v-spacer></v-spacer>
      <v-icon v-if="!$vuetify.theme.dark" class="mr-1">mdi-white-balance-sunny</v-icon>
      <v-icon v-if="$vuetify.theme.dark" class="mr-1">mdi-brightness-2</v-icon>
      <v-switch
              color="orange"
              hide-details
              v-model="$vuetify.theme.dark"
              @change="colorlocal()"

              
            >
        </v-switch>
      <v-app-bar-nav-icon color="indigo darken-1 " class="dr" @click="drawer = !drawer" v-if="$vuetify.breakpoint.width > 960 ? false : true"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" fixed temporary right >


      <v-list nav dense>
        <div class="ma-2 d-flex justify-center">
          <v-text class="text-subtitle-1" style="text-align: center;">目錄</v-text>
        </div>

        <v-divider class="ma-2"></v-divider>

        <v-list-item-group v-model="selectedItem" color="primary">
          <v-list-item v-for="(item, i) in links" :key="i" :href="item.src">

            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="text-subtitle-2" v-text="item.text"></v-list-item-title>
            </v-list-item-content>


          </v-list-item>
        </v-list-item-group>
      </v-list>


    </v-navigation-drawer>

  </v-app>
</template>

<style>
.v-application--wrap {
  min-height: 0vh !important;
}
</style>

<script>
export default {

  data: () => ({
    drawer: null,
    dc_logo: "https://www.dreamcity.studio/images/logo_0218.png",
    links: [
      { icon: "mdi-folder", text: '繪師列表', src: "./" },
    ],

  }),

  mounted () {
    this.$vuetify.theme.dark = (window.localStorage.getItem('theme') == 'true');
  },

  methods:{
    colorlocal(){
      window.localStorage.setItem('theme', this.$vuetify.theme.dark);

    }

  }




}
</script>